module.exports = __webpack_public_path__ + "img/25.6.CODm.27b1e6c0.png";